
  if (!customElements.get('lp-halloween-offer')) {
    customElements.define('lp-halloween-offer', class extends HTMLElement {
      connectedCallback() {
        this.copyButton = this.querySelector('.lp-halloween__copy');
        this.pauseButton = this.querySelector('.lp-halloween__pause');
        this.feedback = this.querySelector('.lp-halloween__feedback');
        this.timeFields = Object.fromEntries([...this.querySelectorAll('[data-time]')].map(node => [node.dataset.time, node]));
        this.onCopy = () => this.copyCode();
        this.onPause = () => {
          const paused = this.classList.toggle('is-paused');
          this.pauseButton.setAttribute('aria-pressed', String(paused));
          this.pauseButton.setAttribute('aria-label', paused ? this.dataset.resumeLabel : this.dataset.pauseLabel);
        };
        if (this.copyButton) { this.copyButton.disabled = false; this.copyButton.addEventListener('click', this.onCopy); }
        this.pauseButton.disabled = false;
        this.pauseButton.addEventListener('click', this.onPause);
        this.update();
        this.interval = window.setInterval(() => this.update(), 1000);
        this.resizeObserver = new ResizeObserver(() => this.updateHeight());
        this.resizeObserver.observe(this);
      }
      disconnectedCallback() {
        window.clearInterval(this.interval);
        window.clearTimeout(this.feedbackTimeout);
        this.resizeObserver?.disconnect();
        this.copyButton?.removeEventListener('click', this.onCopy);
        this.pauseButton?.removeEventListener('click', this.onPause);
      }
      updateHeight() {
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.getBoundingClientRect().height}px`);
      }
      update() {
        const start = Date.parse(this.dataset.start);
        const end = Number(this.dataset.endSeconds) * 1000;
        const now = Date.now();
        let phase = 'ended';
        if (Number.isFinite(start) && Number.isFinite(end) && end > start) phase = now < start ? 'upcoming' : now < end ? 'active' : 'ended';
        if (window.Shopify?.designMode && this.dataset.editorPhase !== 'auto') phase = this.dataset.editorPhase;
        if (this.dataset.phase !== phase) { this.dataset.phase = phase; this.updateHeight(); }
        const total = Math.max(0, Math.ceil(((phase === 'upcoming' ? start : end) - now) / 1000));
        const values = { days: Math.floor(total / 86400), hours: Math.floor(total % 86400 / 3600), minutes: Math.floor(total % 3600 / 60), seconds: total % 60 };
        for (const [unit, node] of Object.entries(this.timeFields)) {
          const value = String(values[unit]).padStart(2, '0');
          if (node.textContent !== value) node.textContent = value;
        }
      }
      async copyCode() {
        let copied = false;
        if (navigator.clipboard?.writeText) { try { await navigator.clipboard.writeText(this.dataset.copyCode); copied = true; } catch {} }
        if (!copied) {
          const input = document.createElement('textarea');
          input.value = this.dataset.copyCode;
          input.style.cssText = 'position:fixed;left:-9999px;top:0;';
          input.setAttribute('readonly', '');
          document.body.append(input);
          input.select();
          try { copied = document.execCommand('copy'); } catch {}
          input.remove();
          this.copyButton.focus({ preventScroll: true });
        }
        window.clearTimeout(this.feedbackTimeout);
        this.feedback.textContent = copied ? this.dataset.copied : this.dataset.copyFailed;
        const label = this.copyButton.querySelector('span');
        if (!this.originalLabel) this.originalLabel = label.textContent;
        label.textContent = copied ? this.dataset.copied : this.originalLabel;
        this.feedbackTimeout = window.setTimeout(() => { label.textContent = this.originalLabel; this.feedback.textContent = ''; }, 2500);
      }
    });
  }
